import { IonButton, IonIcon } from '@ionic/react';
import { backspace } from 'ionicons/icons';
import React from 'react';

interface Props {
    value: string;
    onChange: (value: string) => void;
    maxLength?: number;
    numericOnly?: boolean;
    emailMode?: boolean;
}

const KEYS_ALPHA = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
];

const KEYS_EMAIL = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
];

const KEYS_EMAIL_SPECIAL = ['@', '.', '_', '-', '.com', '.com.br'];

const KEYS_NUMERIC = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['', '0', ''],
];

const TecladoVirtual: React.FC<Props> = ({ value, onChange, maxLength = 30, numericOnly = false, emailMode = false }) => {

    function handleKey(key: string) {
        if (value.length < maxLength) {
            onChange(value + (emailMode ? key.toLowerCase() : key));
        }
    }

    function handleBackspace() {
        onChange(value.slice(0, -1));
    }

    function handleSpace() {
        if (value.length < maxLength) {
            onChange(value + ' ');
        }
    }

    const keys = numericOnly ? KEYS_NUMERIC : emailMode ? KEYS_EMAIL : KEYS_ALPHA;

    return (
        <div className="teclado-virtual">
            {keys.map((row, rowIdx) => (
                <div key={rowIdx} className="teclado-row">
                    {row.map((key, keyIdx) =>
                        key ? (
                            <IonButton
                                key={keyIdx}
                                className="teclado-key"
                                fill="outline"
                                color="dark"
                                onClick={() => handleKey(key)}
                            >
                                {emailMode ? key.toLowerCase() : key}
                            </IonButton>
                        ) : (
                            <div key={keyIdx} className="teclado-key-spacer" />
                        )
                    )}
                    {/* {rowIdx === keys.length - 1 && !numericOnly && !emailMode && (
             
                    )} */}
                </div>
            ))}

            {emailMode && (
                <div className="teclado-row">
                    {KEYS_EMAIL_SPECIAL.map((key, keyIdx) => (
                        <IonButton
                            key={keyIdx}
                            className="teclado-key teclado-key-special"
                            fill="outline"
                            color="totem"
                            onClick={() => handleKey(key)}
                        >
                            {key}
                        </IonButton>
                    ))}
                    <IonButton className="teclado-key teclado-key-backspace" fill="outline" color="danger" onClick={handleBackspace}>
                        <IonIcon icon={backspace} />
                    </IonButton>
                </div>
            )}

            <div className="teclado-row teclado-row-bottom">
                {!numericOnly && !emailMode && (
                    <>
                        <IonButton className="teclado-key teclado-key-space" fill="outline" color="dark" onClick={handleSpace}>
                            Espaço
                        </IonButton>
                        <IonButton className="teclado-key teclado-key-backspace" fill="outline" color="danger" onClick={handleBackspace}>
                            <IonIcon icon={backspace} />
                        </IonButton>
                    </>

                )}


            </div>
        </div>
    );
};

export default TecladoVirtual;
